"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StripButtonsAndOverlaysPlugin = _interopRequireDefault(require("draft-plugins/plugins/StripButtonsAndOverlaysPlugin"));

var _BlockStyles = _interopRequireDefault(require("draft-plugins/plugins/BlockStyles"));

var _link = _interopRequireDefault(require("draft-plugins/plugins/link"));

var _InlineStyles = _interopRequireDefault(require("draft-plugins/plugins/InlineStyles"));

var _EmbedPlugin = _interopRequireDefault(require("composer-plugins/plugins/embed/EmbedPlugin"));

var _ImagePlugin = _interopRequireDefault(require("composer-plugins/plugins/ImagePlugin"));

var _VideoPlugin = _interopRequireDefault(require("composer-plugins/plugins/video/VideoPlugin"));

var _VideoContainer = _interopRequireDefault(require("composer-plugins/plugins/video/VideoContainer"));

var _VideoComponent = _interopRequireDefault(require("composer-plugins/plugins/video/VideoComponent"));

var _QuestionSubmissionsPlugin = _interopRequireDefault(require("composer-plugins/plugins/QuestionSubmissionsPlugin"));

var _default = function _default(_ref) {
  var props = _ref.props;
  return (0, _StripButtonsAndOverlaysPlugin.default)((0, _InlineStyles.default)(), (0, _BlockStyles.default)({
    headerStyles: [],
    miscStyles: []
  }), (0, _link.default)(), (0, _EmbedPlugin.default)({
    props: props
  }), (0, _ImagePlugin.default)({
    props: props
  }), (0, _VideoPlugin.default)({
    props: props,
    VideoComponent: (0, _VideoContainer.default)(_VideoComponent.default)
  }), (0, _QuestionSubmissionsPlugin.default)({
    props: props
  }));
};

exports.default = _default;
module.exports = exports.default;